module.exports = __webpack_public_path__ + "media/images/recruit/top/bg_none-39286088fe1651e28b99ab49b77fa3d1.jpg";